(function () {
    'use strict';

    angular.module("imApp").factory("productSettingMcService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3060,
                    parameters: parms || {}
                });
            },
            listMetaColumns: function (parms) {
                return $ihttp.post({
                    method: 3062,
                    parameters: parms || {}
                });
            },
            listProductSettingMcItems: function (parms) {
                return $ihttp.post({
                    method: 3561,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3063,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3064,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
